"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var SearchCriteriaText = /** @class */ (function (_super) {
    __extends(SearchCriteriaText, _super);
    function SearchCriteriaText() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SearchCriteriaText.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement("h4", null, "Search Criteria"),
            React.createElement("div", null, "Please enter search criteria below. Click the blue question mark for an explanation of a search criterion. Click \"Search\" to find plans matching the criteria you entered. Your criteria are saved for the duration of your visit to the website, unless cleared by clicking \"Clear Search Criteria.\"")));
    };
    return SearchCriteriaText;
}(React.PureComponent));
;
exports.default = SearchCriteriaText;
//# sourceMappingURL=SearchCriteriaText.js.map